import i18next from 'i18next'

export const formatDate = (dateString: string): string => {
    const t = i18next.t.bind(i18next)
    const date = new Date(dateString)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const days = t('common.days', { returnObjects: true }) as string[]
    const dayOfWeek = days[date.getDay()]

    return t('common.dateFormat', { year, month, day, dayOfWeek })
}

export const formatTime = (dateString: string): string => {
    const t = i18next.t.bind(i18next)
    const date = new Date(dateString)
    const hours = date.getHours()
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const period = t(hours < 12 ? 'common.am' : 'common.pm')
    const displayHours = hours % 12 || 12

    return t('common.timeFormat', { period, hours: displayHours, minutes })
}
